var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")

let ShareUtil = require("clover/utils/ShareUtil")
var PassLevelWinScoreOverFrinedShare = xClass("PassLevelWinScoreOverFrinedShare", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/level_share_level_share.csb")
})

PassLevelWinScoreOverFrinedShare.show = function (type, showoffRankoverData, failCb, levelId) {
    var onSuccess = function(evt){
        if (evt.data.overLimit){
            if (failCb){
                failCb();
            }
            return;
        }
        var resSuccess = function() {
            PassLevelWinScoreOverFrinedShare.create(type, showoffRankoverData, levelId);
            if (type < 3){
                DCAssist.userTrack("share", "level_showoff_share_show", {"type":2});
            }else{
                DCAssist.userTrack("share", "level_showoff_share_show", {"type":3});
            }
        }
        onFail = failCb || Toast.make(getText("error.tip.load_res_error"));
        onCancel = failCb || Toast.make(getText("error.tip.load_canceled"));
        preloadWithLoading(["packed/WinShareRes.pack"], resSuccess, onFail, onCancel)
    }

    var uid = UserManager.getInstance().uid;
    var http = PassLevelShowOffSuccHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    if (failCb){
        http.addEventListener(Events.kError, failCb);
        http.addEventListener(Events.kCancel, failCb);
    }
    http.load(uid, false);
}

// type:1 分数超过好友，2 分数第一，3 关卡书超过好友
PassLevelWinScoreOverFrinedShare.prototype.ctor = function (type, showoffRankoverData, shareToFriendData) {
    var self = this;
    self.bind(self);
    BasePanel.prototype.init.call(self);
    self.rankPassOver = false;
    self.rankTop = false;
    self.LevelPassOver = false;
    self.topLevel = false;
    self.showoffRankoverData = showoffRankoverData;
    self.levelId = shareToFriendData.levelId;
    self.score = shareToFriendData.score || 0;
    if (type == 1){
        self.rankPassOver = true;
    }else if(type == 2){
        self.rankTop = true;
    }else if(type == 3){
        self.LevelPassOver = true;
    }
    self.init();
    self.popup();

    self.notHideBannerOnClose();
}


PassLevelWinScoreOverFrinedShare.prototype.init = function () {
    var self = this;
    self.check = true;
    
    label = self.getChildByName("btn").getChildByName("label");
    label.setString(getText("passlevel.showoff.firstplace.button"));
    // label.x += 26

    var okBtn = UIGroupButton.create(self.getChildByName("btn"));
    PushBounceAnim.create(okBtn);
    ButtonPushBounceIdleBubbleAnim.create(okBtn);
    self.shareTimer = 2800;
    CfgManager.load("game").then(()=>{
        self.shareTimer = CfgManager.get("game").time_match_timer;
        CfgManager.release("game");
    }).catch((err) => {
        console.error("load game config failed!", err);
    });  
    okBtn.clickTimes = 0;
    okBtn.on(UIButtonEvent.Click, function () {
        //  按钮点击数
        okBtn.clickTimes += 1;
        if (self.showoffRankoverData){
            // cc.UserDefault.getInstance().setStringForKey(LOCAL_PASS_LEVEL_SHOWOFF_FIRST, self.showoffRankoverData);
            Persistence.writeFileData(self.showoffRankoverData, LocalDataFiles.kPassLevelShowoffFirst);
        }
        if (self.check){
            //  检查当前平台是否支持定向分享，支持则发送分享消息
            if (okBtn.clickTimes === 1 && window.mini && mini.supportShareMessageToFriend() && MetaManager.getInstance().supportShareToFriend()) {
                //  设定按钮禁用时间
                okBtn.setEnabled(false);
                okBtn.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
                    okBtn.setEnabled(true);
                })))
                //  执行定向分享
                var groupData = TextsManager.getInstance().getRandomTexts(MetaManager.getInstance().getOrientedShareGroupName("passlevel_showoff"))
                //  因为要修改content内容，所以必须要深拷贝一份，否则下次就没法再通过{level}进行替换了
                if (groupData.content.indexOf("{level}")) {
                    let sendData = JSON.parse(JSON.stringify(groupData))
                    sendData.content = sendData.content.replace("{level}", "第" + self.levelId);
                    var content = sendData.content;
                } else {
                    var content = groupData.content;
                }
                var type = self.rankPassOver ? 1 : (self.LevelPassOver ? 3 : 0);
                if (window.mini) {
                    if(mini.supportOpenContext()){
                        mini.setMessageToFriendQuery({
                            shareMessageToFriendScene: ShareToFriendScene.ScoreOverFriend
                        });
                        OpenContextUtil.postMessage({
                            command: "share message to friend",
                            openid: META.user.openid,
                            levelId: self.levelId,
                            score: self.score,
                            title: content,
                            imageUrl: groupData.bg.substr(groupData.bg.indexOf("sflink:||") + "sflink:||".length),
                            showoffType: type
                        });
                    }
                    if (mini.supportOnFdShareMsg()) {
                        // 监听定向分享结果
                        mini.onShareMessageToFriend((res)=> {
                            if (res.success) {
                                DCAssist.dc4SMFShareSent("smf_passlevel_showoff");
                            }
                        });
                    }
                }
            } else {
                //  设定分享类型
                var showoffType = 2;
                if (self.LevelPassOver){
                    showoffType = 3;
                }
                function onShareComplete() {
                    self.onClose();
                }
                ShareUtil.clickPassLevelShowOff({"type":showoffType}, onShareComplete, onShareComplete, onShareComplete, )
            }
        } else {
            self.onClose();
        }
    })

    var checkBtn = UIButton.create(self.getChildByName("checkmark_share").getChildByName("checkmark_bg"));
    checkBtn.on(UIButtonEvent.Click, function () {
        self.check = !self.check;
        self.getChildByName("checkmark_share").getChildByName("checkmark").setVisible(self.check);
    })
    var checkTxt = self.getChildByName("checkmark_share").getChildByName("txt");
    checkTxt.setString(getText("passlevel.showoff.firstplace.sharetext"));
    checkTxt.y -= 4;

    if (self.rankPassOver){
        self.getChildByName("txt").setString(getText("passlevel.showoff.surpass.text"));
        self.getChildByName("txt").setScale(35/40);
        self.getChildByName("txt").setNextFontPositionXOffset(-3);
        self.getChildByName("txt").x -= 50;
        self.getChildByName("txt").y -= 7;
    }else if(self.rankTop){
        self.getChildByName("txt").setString(getText("passlevel.showoff.firstplace.text"));
        self.getChildByName("txt").setScale(35/40);
        self.getChildByName("txt").setNextFontPositionXOffset(-3);
        self.getChildByName("txt").x -= 20;
        self.getChildByName("txt").y -= 7;
    }else if(self.LevelPassOver){
        self.getChildByName("txt").setString(getText("passlevel.levelnum.surpass.text"));
        self.getChildByName("txt").setScale(35/40);
        self.getChildByName("txt").setNextFontPositionXOffset(-3);
        self.getChildByName("txt").x += 60;
        self.getChildByName("txt").y -= 7;
    }

    self.getChildByName("btn").getChildByName("label").x += 25;
    self.getChildByName("btn").getChildByName("label").y -= 2;


    if (!window.mini || !mini.supportShareMessageToFriend() || !MetaManager.getInstance().supportShareToFriend()) {
        DCAssist.dc4ShareShow("pass_level_showoff");
    }
}

PassLevelWinScoreOverFrinedShare.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(55, 650 + dH/2));
    var pos_O = cc.p(display.width / 2, display.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

PassLevelWinScoreOverFrinedShare.prototype.onCleanup = function () {
    ResManager.release(["packed/WinShareRes.pack"]);
}

PassLevelWinScoreOverFrinedShare.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

    if (window.mini && mini.supportOnFdShareMsg()) {
        mini.onShareMessageToFriend(null);
    }
}

module.exports = PassLevelWinScoreOverFrinedShare;